<template>
  <RouterLink
    :class="{ teaser : subModule.authority === 'teaser'}"
    class="submodule"
    :to="getRouterPath(subModule.key)"
    active-class="active-sub-module"
    @click.native="hideMenu"
  >
    <div class="name">
      {{ subModule.moduleName }}
    </div>
    <div class="description">
      {{ subModule.description }}
    </div>
  </RouterLink>
</template>

<script>
import menuComponent from '@/components/layout/navigation/menu/mixins/menuComponent';
import routerUtils from '@/components/common/mixins/routerUtils';

export default {
  name: 'MenuSubModule',
  mixins: [menuComponent, routerUtils],
  props: {
    subModule: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  a.submodule {
    &:hover:not(.active-sub-module) {
      .name {
        transform: translateX(3px);
      }
    }

    &.active-sub-module {
      &::before {
        content: '';
        height: 100%;
        background-color: var(--accent-bg-hex);
        width: 2px;
        left: -1px;
        right: auto;
        position: absolute;
      }

      overflow: visible;

      .name {
        transform: translateX(10px);
        color: var(--primary-text-alt-color-hex);
        background: linear-gradient(to right, var(--menu-sub-module-text-hex) 20%, var(--primary-text-alt-color-hex) 50%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: 200% auto;
        animation: textShine 0.65s ease-in-out 1 forwards;
      }
    }

    &.teaser {
      opacity: 0.4;
    }

    padding: 12px 0 12px 30px;
    overflow: hidden;
    color: var(--menu-sub-module-text-hex);
    position: relative;
    transition: border 0.1s;
    display: grid;
    grid-template-areas: "name";
    grid-template-columns: 1fr;
    align-items: center;

    .name {
      transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1);
      font-size: 13px;
      grid-area: name;
      font-weight: 400;
    }

    .description {
      font-size: 14px;
      grid-area: description;
    }
  }

  @keyframes textShine {
    to {
      background-position: -100%;
    }
  }
</style>
